import React from 'react';

import { View } from 'react-native';

import OPComponent from '../op_component';
import Alert from '../platform_wrappers/alert';
import { COLOR, THEME } from '../../../constants/styles';

import NavBar from '../../../navbar';
import Navigation from '../../../navigation';
import I18n from '../../../I18n';

class VideoView extends OPComponent {
  constructor(props) {
    super(props);

    this.unMounted = true;

    this.state = {};
  }

  navigationButtonPressed = ({ buttonId }) => {
    if (NavBar.handleButtonPress2(buttonId, this)) return;
  };

  componentDidMount() {
    this.unMounted = false;

    Navigation.registerForButtonEvents(this);
  }
  componentWillUnmount() {
    this.unMounted = true;

    Navigation.unRegisterForButtonEvents(this);
  }

  handleLoadError = () => {
    Alert.alert(
      I18n.t('components.anErrorHasOccurred'),
      I18n.t('components.cannotPlayVideo'),
      [
        {
          text: I18n.ac('ok'),
          onPress: () => Navigation.dismissModal(this.props.componentId),
        },
      ],
      { cancelable: false }
    );
  };

  render() {
    const { imageUri } = this.props;
    return (
      <View style={THEME.container}>
        <video
          width="100%"
          height="100%"
          autoPlay={true}
          controls={true}
          onLoadStart={this.onLoadStart}
          onLoad={this.onLoad}
          onProgress={this.onProgress}
          onError={this.handleLoadError}
        >
          <source src={imageUri} type="video/mp4" />
        </video>
      </View>
    );
  }
}

export default VideoView;
